import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

export const MODE_REM_ORDER = "rem_order"
export const MODE_STORE_LOCATION = "store_location"
export const MODE_MANUAL = "manual"

const MODES = [MODE_REM_ORDER, MODE_STORE_LOCATION, MODE_MANUAL]

const MODE_LABEL_KEY = {
  [MODE_REM_ORDER]: "mode_rem_order",
  [MODE_STORE_LOCATION]: "mode_store_location",
  [MODE_MANUAL]: "mode_manual",
}

export default function ModeSelector({ mode, onChange, disabled }) {
  const { t } = useTranslation()

  return (
    <fieldset className="mb-4">
      <legend className="block text-sm font-medium text-gray-700 mb-2">
        {t("natura_operations.deposit_transfer.mode_label")}
      </legend>
      <div className="flex flex-wrap gap-4">
        {MODES.map((m) => (
          <label key={m} className="inline-flex items-center gap-2 text-sm">
            <input
              type="radio"
              name="deposit-transfer-mode"
              value={m}
              checked={mode === m}
              disabled={disabled}
              onChange={() => onChange(m)}
              className="text-amber-500 focus:ring-amber-500"
            />
            {t(`natura_operations.deposit_transfer.${MODE_LABEL_KEY[m]}`)}
          </label>
        ))}
      </div>
    </fieldset>
  )
}

ModeSelector.propTypes = {
  mode: PropTypes.oneOf(MODES).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

ModeSelector.defaultProps = {
  disabled: false,
}
